// extracted by mini-css-extract-plugin
export default {"productCarousel":"c0-z"};